module.exports = __webpack_public_path__ + "static/media/icons_Bilan Thoracique MDT.6798d1ee.svg";